import React from 'react';
import { init } from '../../api/analytics/google';
import { connect } from 'react-redux';
import { getBrandCommon } from '../../api/redux-watson/watson-config-selectors';

class AnalyticsInit extends React.Component {
  componentDidMount() {
    init(this.props.trackingCode);
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  trackingCode: getBrandCommon(state).gaTrackingCode,
});

export default connect(mapStateToProps)(AnalyticsInit);



// WEBPACK FOOTER //
// ./src/app/ui/analytics/AnalyticsInit.js